(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bv-overlay-fix"] && !Shopify.designMode) return;
  try {
    (function () {
    const overlayClass = 'bv-overlay-open';
    const modalSelector = '.bv-ips-modal-window, [class*="bv-ips-modal"]';
    let overlayIsOpen = false;
    let overlayLockedScroll = false;

    const hasModal = function (root) {
      if (!root || !root.querySelector) {
        return false;
      }

      if (root.querySelector(modalSelector)) {
        return true;
      }

      const nodes = root.querySelectorAll('*');

      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].shadowRoot && hasModal(nodes[i].shadowRoot)) {
          return true;
        }
      }

      return false;
    };

    const getStopScroll = function () {
      if (window.Alpine && typeof window.Alpine.store === 'function') {
        return window.Alpine.store('stop-scroll');
      }

      return null;
    };

    const lockPageScroll = function () {
      const applyLock = function () {
        const stopScroll = getStopScroll();

        if (!stopScroll || overlayLockedScroll || !stopScroll.isScrollable) {
          return;
        }

        stopScroll.enable();
        overlayLockedScroll = true;
        document.documentElement.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('overflow-y');
      };

      if (getStopScroll()) {
        applyLock();
        return;
      }

      document.addEventListener('alpine:initialized', applyLock, { once: true });
    };

    const unlockPageScroll = function () {
      const stopScroll = getStopScroll();

      if (!overlayLockedScroll) {
        return;
      }

      if (stopScroll) {
        stopScroll.disable();
      }

      overlayLockedScroll = false;
    };

    const syncOverlayState = function () {
      const open = hasModal(document);

      if (open === overlayIsOpen) {
        return;
      }

      overlayIsOpen = open;
      document.documentElement.classList.toggle(overlayClass, open);

      if (open) {
        lockPageScroll();
      } else {
        unlockPageScroll();
      }
    };

    const observer = new MutationObserver(syncOverlayState);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    document.addEventListener(
      'click',
      function () {
        window.setTimeout(syncOverlayState, 50);
        window.setTimeout(syncOverlayState, 400);
      },
      true,
    );

    syncOverlayState();
  })();
  } catch(e) { console.error(e); }
})();

})();
